import React from "react";
import { useLocation } from "react-router-dom";

import ToolLayout from "../ToolLayout";
import MeasurementCalculatorTool from "./MeasurementCalculatorTool";
import MeasurementCalculatorConfig from "./MeasurementCalculator.config";

/**
 * MeasurementCalculatorPage
 *
 * Standalone, SEO-indexable page wrapper for the Measurement Calculator tool.
 *
 * Example URL:
 * /tools/measurement-calculator?category=flooring
 */
const MeasurementCalculatorPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const category = params.get("category") || undefined;

  return (
    <ToolLayout
      title={MeasurementCalculatorConfig.title}
      description={MeasurementCalculatorConfig.description}
    >
      <MeasurementCalculatorTool category={category} />
    </ToolLayout>
  );
};

export default MeasurementCalculatorPage;
